import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const NEW_EDITOR_ERROR_CATEGORIES = {
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  UNKNOWN: 'UNKNOWN'
};
export const NEW_EDITOR_ERROR_SUB_CATEGORIES = {
  UNKNOWN_USER_ERROR: 'HubspotFormsError.UNKNOWN_USER_ERROR'
};
export const fetchDefaultStyles = () => http.get('hubspot-forms/v1/styles', {
  query: {
    portalId: `${PortalIdParser.get()}`
  }
});

// TODO: Fix types
export const createRawNewEditorForm = payload => http.post('hubspot-forms/v1/form', {
  data: payload
});
export const createNewDefaultForm = ({
  businessUnitId
}) => http.post(`forms-generation/v1/hubspot-form/default?portalId=${PortalIdParser.get()}`, {
  data: {
    businessUnitId
  }
});
export const createFormFromTemplate = payload => http.post('forms-generation/v1/hubspot-form/from-template', {
  data: payload
});